import cn from 'classnames';
import React from 'react';

import {Footer} from 'components/footer';
import {ImageWithFallback} from 'components/image-with-fallback';
import {ModalRoot} from 'components/modal';
import backgroundPng from 'shared/assets/auth-bg.png';
import backgroundWebp from 'shared/assets/auth-bg.webp';
import {ReactComponent as LogoIcon} from 'shared/assets/main-logo.svg';
import {DEFAULT_THEME} from 'shared/constants/layout';
import {TJSXContent} from 'shared/types';

import './auth-page.less';

interface IAuthPageProps {
    className?: cn.Argument;
    children?: TJSXContent;
}

export const AuthPage = ({className, children}: IAuthPageProps) => (
    <div className={cn('auth-page', className)}>
        <ImageWithFallback
            className="auth-page__background"
            fallbackImageUrl={backgroundPng}
            imageUrl={backgroundWebp}
            isBackground
        />
        <div className="auth-page-logo">
            <LogoIcon className="auth-page-logo__icon" />
            <div className="auth-page-logo__name">
                Витрина<br />
                налогового<br />
                мониторинга
            </div>
            {process.env.REACT_APP_THEME !== DEFAULT_THEME && (
                <div
                    className="auth-page__partner-logo"
                >
                    <img
                        src={`${process.env.PUBLIC_URL}/logos/${process.env.REACT_APP_THEME}-light.svg`}
                        alt="Логотип портала."
                    />
                </div>
            )}
        </div>
        {children}
        <Footer />
        <ModalRoot />
    </div>
);
